import React from 'react';
import PropTypes from 'prop-types';

import {
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton,
} from 'react-share';

const SocialShare = (props) => {
  const { url, pinterestImage } = props;
  return (
    <div className="text-center pt-3 mt-2 mb-0">
      <FacebookShareButton url={url}>Facebook</FacebookShareButton>
      &nbsp;&ndash;&nbsp;
      <TwitterShareButton url={url}>Twitter</TwitterShareButton>
      &nbsp;&ndash;&nbsp;
      <PinterestShareButton url={url} media={pinterestImage}>
        Pinterest
      </PinterestShareButton>
    </div>
  );
};

SocialShare.propTypes = {
  url: PropTypes.string.isRequired,
  pinterestImage: PropTypes.string.isRequired,
};

export default SocialShare;
